import * as detailPageActions from '../actions/detailPage';

const defaultState = {
    model: null,
    isResourceCodeSubmitted: false,
    resourcePacks: [],
    openAccordions: ['overview'],
    isShowingEventResources: false
};

export default function(state = defaultState, action) {

    switch (action.type) {

        case detailPageActions.RESET_EVENT_DETAIL:

            return defaultState;

        case detailPageActions.EVENT_DETAIL_SHOW_RESOURCE_PACKS:

            return {
                ...state,
                isResourceCodeSubmitted: true,
                resourcePacks: action.packs
            };

        case detailPageActions.EVENT_DETAIL_REFRESHED:

            return {
                ...state,
                model: action.model
            };

        case detailPageActions.TOGGLE_EVENT_DETAIL_ACCORDION:

            var openAccordions = [];

            if (state.openAccordions.includes(action.accordionKey)) {

                openAccordions = state.openAccordions.filter((accordionKey) => {

                    return accordionKey !== action.accordionKey;
                });

            } else  {

                openAccordions = state.openAccordions.concat([action.accordionKey])
            }

            return {
                ...state,
                openAccordions
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/detailPage.js